import { render, staticRenderFns } from "./LostPasswordConfirmation.vue?vue&type=template&id=483be0b2&scoped=true&"
import script from "./LostPasswordConfirmation.vue?vue&type=script&lang=js&"
export * from "./LostPasswordConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483be0b2",
  null
  
)

export default component.exports